module.exports = __webpack_public_path__ + "static/media/romanticos_feminino_roupas.aa34c1b0.jpg";